import React from 'react';

interface MobilePreviewProps {
  children: React.ReactNode;
  ariaLabel: string;
}

const MobilePreview: React.FC<MobilePreviewProps> = ({ children, ariaLabel }) => {
  return (
    <div className="mobile-frame" role="presentation" aria-hidden="false">
      <div className="mobile-notch" aria-hidden="true" />
      <div className="mobile-screen">
        <div className="figma-accueil-canvas" role="presentation" aria-label={ariaLabel}>
          {children}
        </div>
      </div>
      <div className="mobile-home-bar" aria-hidden="true" />
    </div>
  );
};

export default MobilePreview;
